import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/react-perfect-scrollbar@1.5.8_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-perfect-scrollbar/dist/css/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/.pnpm/sonner@2.0.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/assets/iconify-icons/generated-icons.css");
